// extracted by mini-css-extract-plugin
module.exports = {"ourWorkSection":"b7_gR","caseStudiesList":"b7_gS","linkSection":"b7_gT","viewMore":"b7_T","caseStudiesContainer":"b7_gV"};